import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  DIAM_API_PATH,
  DIAM_TEAM_ID,
  diamQueryKeys,
  replaceTeamApplicationContexts,
  updateTeam,
} from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';
import { mapUpdateTeamApiRequest } from '../CreateTeamDrawer/mapTeamApiRequest';
import { UpdateTeamSubmitPayload } from './types';

export function useUpdateTeam() {
  const { getIdToken, apiUrl } = useApiEssentials(DIAM_API_PATH);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: UpdateTeamSubmitPayload) => {
      const idToken = await getIdToken();
      const { id, ...formPayload } = payload;

      await updateTeam(
        apiUrl,
        idToken,
        id,
        mapUpdateTeamApiRequest(formPayload),
      );
      await replaceTeamApplicationContexts(
        apiUrl,
        idToken,
        id,
        formPayload.applications,
      );
    },
    onSettled: (_data, _error, payload) => {
      queryClient.invalidateQueries({ queryKey: ['diam', 'teams', 'page'] });
      queryClient.invalidateQueries({
        queryKey: diamQueryKeys.team(payload.id),
      });
      queryClient.invalidateQueries({
        queryKey: diamQueryKeys.teamApplicationContexts(payload.id),
      });
      queryClient.invalidateQueries({
        queryKey: diamQueryKeys.teamTree(DIAM_TEAM_ID),
      });
    },
  });
}
